import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex items-center cursor-pointer" onClick={() => scrollToSection('home')}>
            <img 
              src="https://static.readdy.ai/image/d4d15a92ee1c2420cdaf087436c6fd41/51c65deb45396ade29b9d8b56a2a268f.png" 
              alt="Karolay Cleaning Services Logo" 
              className={`h-32 w-auto object-contain transition-all duration-300 mt-20 ${isScrolled ? 'opacity-100' : 'opacity-80 mix-blend-luminosity brightness-150'}`}
            />
          </div>

          <div className="hidden md:flex items-center space-x-8">
            <button onClick={() => scrollToSection('home')} className={`text-sm font-medium transition-colors whitespace-nowrap hover:text-teal-600 ${isScrolled ? 'text-gray-700' : 'text-white'}`}>
              Home
            </button>
            <button onClick={() => scrollToSection('about')} className={`text-sm font-medium transition-colors whitespace-nowrap hover:text-teal-600 ${isScrolled ? 'text-gray-700' : 'text-white'}`}>
              About Us
            </button>
            <button onClick={() => scrollToSection('services')} className={`text-sm font-medium transition-colors whitespace-nowrap hover:text-teal-600 ${isScrolled ? 'text-gray-700' : 'text-white'}`}>
              Services
            </button>
            <button onClick={() => scrollToSection('before-after')} className={`text-sm font-medium transition-colors whitespace-nowrap hover:text-teal-600 ${isScrolled ? 'text-gray-700' : 'text-white'}`}>
              Before & After
            </button>
            <button onClick={() => scrollToSection('pricing')} className={`text-sm font-medium transition-colors whitespace-nowrap hover:text-teal-600 ${isScrolled ? 'text-gray-700' : 'text-white'}`}>
              Pricing
            </button>
            <button onClick={() => scrollToSection('testimonials')} className={`text-sm font-medium transition-colors whitespace-nowrap hover:text-teal-600 ${isScrolled ? 'text-gray-700' : 'text-white'}`}>
              Testimonials
            </button>
            <button onClick={() => scrollToSection('contact')} className="bg-teal-600 text-white px-6 py-2.5 rounded-lg text-sm font-medium hover:bg-teal-700 transition-colors whitespace-nowrap">
              Get a Quote
            </button>
          </div>

          <button 
            className="md:hidden p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <i className={`ri-menu-line text-2xl ${isScrolled ? 'text-gray-700' : 'text-white'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-white shadow-lg">
          <div className="px-4 py-4 space-y-3">
            <button onClick={() => scrollToSection('home')} className="block w-full text-left text-sm font-medium text-gray-700 hover:text-teal-600 py-2 whitespace-nowrap">
              Home
            </button>
            <button onClick={() => scrollToSection('about')} className="block w-full text-left text-sm font-medium text-gray-700 hover:text-teal-600 py-2 whitespace-nowrap">
              About Us
            </button>
            <button onClick={() => scrollToSection('services')} className="block w-full text-left text-sm font-medium text-gray-700 hover:text-teal-600 py-2 whitespace-nowrap">
              Services
            </button>
            <button onClick={() => scrollToSection('before-after')} className="block w-full text-left text-sm font-medium text-gray-700 hover:text-teal-600 py-2 whitespace-nowrap">
              Before & After
            </button>
            <button onClick={() => scrollToSection('pricing')} className="block w-full text-left text-sm font-medium text-gray-700 hover:text-teal-600 py-2 whitespace-nowrap">
              Pricing
            </button>
            <button onClick={() => scrollToSection('testimonials')} className="block w-full text-left text-sm font-medium text-gray-700 hover:text-teal-600 py-2 whitespace-nowrap">
              Testimonials
            </button>
            <button onClick={() => scrollToSection('contact')} className="bg-teal-600 text-white px-6 py-2.5 rounded-lg text-sm font-medium hover:bg-teal-700 transition-colors w-full whitespace-nowrap">
              Get a Quote
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}